// extracted by mini-css-extract-plugin
export var aboutContent = "about-module--about-content--W1g4y";
export var imageWrapper = "about-module--image-wrapper--bQyYI";
export var aboutTeam = "about-module--about-team--5JJhO";
export var aboutTeamImage = "about-module--about-team-image---67OO";